module.exports = __webpack_public_path__ + "static/img/icon_set.03f17de2.svg";